module.exports = __webpack_public_path__ + "img/portrait-067.0e5d0dc9.jpg";